"use strict";
/**
 * HubShare routes
 */
/* tslint:disable */
module.exports = [
    {
        path: '/hubshare',
        component: function () { return import(/* webpackChunkName: "hubshare" */ 'Views/HubShare/Index/Index.vue'); },
        meta: {
            requiresAuth: true,
            title: 'HUBShares',
        },
    },
    {
        path: '/hubshare/new',
        component: function () { return import(/* webpackChunkName: "hubshare" */ 'Views/HubShare/New/New.vue'); },
        meta: {
            requiresAuth: true,
            title: 'New HUBShare',
        },
    },
    {
        path: '/hubshare/:id(\\d+)',
        component: function () { return import(/* webpackChunkName: "hubshare" */ 'Views/HubShare/Single/Single.vue'); },
        meta: {
            requiresAuth: true,
            title: 'HUBShare',
        },
    },
    {
        path: '/hubshare/:id(\\d+)/edit',
        component: function () { return import(/* webpackChunkName: "hubshare" */ 'Views/HubShare/Edit/Edit.vue'); },
        meta: {
            requiresAuth: true,
            title: 'Edit HUBShare',
        },
    },
];
/* tslint:enable */



// WEBPACK FOOTER //
// ./~/ts-loader??ref--3!./src/js/Router/Routes/HubShare.ts